/*
 * Copyright (c) 2022 FMR LLC.
 * All Rights Reserved.
 * Fidelity Confidential Information.
 */

export enum FederalFilingStatus {
    S = 'S',          // Single
    MFJ = 'MFJ',          // Married Filing Jointly
    MFS = 'MFS',        // Married Filing Separately
    HH = 'HH',        // Head of Household
    QW = 'QW',          // Qualified Widower/Dependent Child
}